import type { FC, ReactNode } from 'react'

import { ExternalLink } from 'lucide-react'
import { ATELIER } from '@/constants/site'

// A hand-drawn style placeholder for the map, until the exact location is added
const MapSketch: FC = (): ReactNode => {
    return (
        <figure>
            <div className='paper-lift'>
                <div className='deckle-wide relative aspect-[4/3] overflow-hidden bg-paper-deep'>
                    <svg
                        viewBox='0 0 600 450'
                        role='img'
                        aria-labelledby='map-sketch-title'
                        className='absolute inset-0 size-full'
                    >
                        <title id='map-sketch-title'>Sketch map: the atelier sits on a stream north-east of Samarkand, about 25 minutes by car from the Registan</title>

                        <g fill='none' stroke='#94806b' strokeOpacity='0.35' strokeWidth='1'>
                            {Array.from({ length: 9 }, (_, index) => (
                                <path key={`h-${index}`} d={`M0 ${50 * index + 25} H600`} strokeDasharray='2 7' />
                            ))}
                        </g>

                        <path d='M-10 330 C 90 300, 160 360, 260 330 S 420 270, 610 300' fill='none' stroke='#6b5544' strokeOpacity='0.4' strokeWidth='10' strokeLinecap='round' />
                        <text x='470' y='325' fill='#6b5544' fontSize='15' style={{ fontFamily: 'var(--font-heading)' }}>Zarafshan</text>

                        <path d='M90 330 C 140 270, 230 230, 300 190 S 410 120, 470 70' fill='none' stroke='#6b5544' strokeOpacity='0.5' strokeWidth='3' strokeLinecap='round' />
                        <text x='175' y='248' fill='#6b5544' fontSize='13' transform='rotate(-29 175 248)' style={{ fontFamily: 'var(--font-heading)' }}>mulberry stream</text>

                        <path d='M170 300 C 230 290, 300 250, 360 165' fill='none' stroke='#6b5544' strokeWidth='2' strokeDasharray='6 6' />
                        <text x='258' y='306' fill='#6b5544' fontSize='13' style={{ fontFamily: 'var(--font-app-sans)' }}>25 min by car</text>

                        <g>
                            <circle cx='160' cy='305' r='26' fill='#3a2a1f' fillOpacity='0.08' />
                            <circle cx='160' cy='305' r='6' fill='#3a2a1f' />
                            <text x='112' y='374' fill='#3a2a1f' fontSize='22' style={{ fontFamily: 'var(--font-heading)' }}>Samarkand</text>
                            <text x='126' y='393' fill='#6b5544' fontSize='12' style={{ fontFamily: 'var(--font-app-sans)' }}>Registan Square</text>
                        </g>

                        <g>
                            <circle cx='362' cy='162' r='22' fill='#a33a2c' fillOpacity='0.16' />
                            <path d='M362 128 C 349 128, 341 137, 341 148 C 341 162, 362 182, 362 182 C 362 182, 383 162, 383 148 C 383 137, 375 128, 362 128 Z' fill='#a33a2c' />
                            <circle cx='362' cy='148' r='6' fill='#f3ebdc' />
                            <text x='395' y='176' fill='#3a2a1f' fontSize='22' style={{ fontFamily: 'var(--font-heading)' }}>Qog&rsquo;oz Atelier</text>
                        </g>

                        <g transform='translate(540 60)' fill='none' stroke='#3a2a1f' strokeWidth='1.5'>
                            <path d='M0 -22 L6 0 L0 22 L-6 0 Z' fill='#3a2a1f' fillOpacity='0.85' />
                            <text x='-5' y='-28' fill='#3a2a1f' stroke='none' fontSize='13' style={{ fontFamily: 'var(--font-heading)' }}>N</text>
                        </g>
                    </svg>
                </div>
            </div>

            <figcaption className='mt-5 flex flex-wrap items-baseline justify-between gap-4 text-sm text-bark-soft'>
                <span className='font-heading text-[0.95rem] italic'>Not to scale. Exact directions arrive with every confirmation.</span>
                <a
                    href={ATELIER.mapsUrl}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='inline-flex items-center gap-1.5 font-medium text-pomegranate'
                >
                    <span className='ink-link pb-0.5'>Open Samarkand in Google Maps</span>
                    <ExternalLink className='size-3.5' strokeWidth={1.75} />
                </a>
            </figcaption>
        </figure>
    )
}

export default MapSketch
